module.exports = __webpack_public_path__ + "img/paypal-bg.32251f3d.svg";